@use "../../sass/global/global" as *;

/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
.ux-iws-location-map {
    &__map-container {
        position: relative;
    }

    &__map-target {
        height: 400px;

        @media only screen and (min-width: $gridle-t-max) {
            height: 500px;
        }
    }

    *[slot="location-details"] {
        max-width: 540px;
        padding: 30px;

        p {
            color: $color-black;
        }

        a {
            display: block;
        }

        @media only screen and (min-width: $gridle-t-max) {
            max-height: calc(100% - 50px);
            overflow: hidden;
            height: auto;
            width: 38%;
            position: absolute;
            bottom: 30px;
            left: 70px;
            padding: 30px;
            z-index: 100;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.9);
        }
    }

    &--location-details &__cookie-notice,
    &--location-details &__privacy-notice {
        display: flex;

        @media only screen and (min-width: $gridle-t-max) {
            justify-content: flex-end;
        }
    }

    &--location-details {
        *[slot="cookie-notice"],
        *[slot="privacy-notice"] {
            padding: 20px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;

            @media only screen and (min-width: $gridle-t-max) {
                width: 55%;
                padding: 45px 45px 30px;
            }
        }
    }

    &--dealer-search &__map-container,
    &--country-locations &__map-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        border: 1px solid $color-gray-borders;

        @media only screen and (min-width: $gridle-t-max) {
            flex-direction: row;
            height: 500px;
        }
    }

    &--dealer-search,
    &--country-locations {
        .ux-iws-location-map__cookie-notice,
        .ux-iws-location-map__privacy-notice {
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            padding: 30px;
        }
    }

    &--dealer-search ux-slider,
    &--country-locations ux-slider {
        position: relative;
        height: 210px;
        max-height: 210px;

        @media only screen and (min-width: $gridle-t-max) {
            height: 450px;
            max-height: 450px;
        }

        &-slide {
            height: auto;
        }

        .ux-slider-container,
        .ux-slider__content-container,
        .ux-slider__inner-container,
        .ux-slider-container {
            height: 100%;
            max-height: 100%;
        }

        .ux-slider-button {
            display: block !important;
            box-shadow: none !important;
            transform: rotate(90deg);
            width: 30px;
            min-width: 30px;
            margin-top: 0;
            background-color: transparent !important;
            left: calc(50% - 15px);

            ux-icon {
                font-size: 30px;
                height: 30px;
                width: 30px;
            }

            &:hover {
                background-color: transparent !important;
            }
        }

        .ux-slider-button-prev {
            top: -43px;
        }

        .ux-slider-button-next {
            top: auto;
            bottom: -39px;
        }
    }

    &--dealer-search &__slider-container,
    &--country-locations &__slider-container {
        padding: 25px 0;
        max-height: 100%;
        position: relative;
        overflow: hidden;

        @media only screen and (min-width: $gridle-t-max) {
            width: 35%;
        }
    }

    .swiper-button-disabled {
        opacity: 0 !important;
    }

    &--dealer-search &__map-target,
    &--country-locations &__map-target {
        @media only screen and (min-width: $gridle-t-max) {
            width: 65%;
        }
    }

    &__location-thumbnail {
        display: flex;
        padding: 13px 20px 12px 25px;
        border-top: 1px solid $color-gray-borders;
        justify-content: flex-start;
        align-items: center;
    }

    &__location-thumbnail-img {
        max-width: 50px;
        padding-right: 10px;

        img {
            width: 100%;
            max-width: 100%;
            height: auto;
        }
    }

    &__location-thumbnail-cta {
        margin-left: auto;
        padding-left: 10px;
    }

    .slide-disabled {
        opacity: 0.3;
    }

    // @deprecated - replaced by ux-iws-location-selection
    &__selection-accordion {
        ux-icon[name="chevron-down"] {
            display: none;
        }

        .ux-accordion__title-container {
            padding: 0 !important;
            border-bottom: 0;
        }

        .ux-accordion__content-container {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        *[slot="title"] {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            max-width: 100%;
        }
    }

    &__legend {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: flex-start;
    }

    &__legend-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 20px;
    }

    &__legend-image {
        height: 40px;
        width: 36px;
        display: inline-block;
        background-size: contain;
        margin-right: 5px;
        margin-top: 5px;
    }

    // @deprecated - replaced by ux-iws-location-selection
    &__locations {
        a {
            text-decoration: none;
            color: $color-black;

            &:hover {
                color: $color-green;
            }
        }

        ul {
            padding-left: 5px;
            margin-top: 5px;
            margin-bottom: 15px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;

            > * {
                width: 100%;

                @media only screen and (min-width: $gridle-t-max) {
                    width: 40%;
                }
            }
        }

        li {
            float: left;
        }
    }

    &__privacy-notice,
    &__cookie-notice {
        height: 100%;

        &--hidden {
            display: none !important;
        }

        &--standby > *[slot="cookie-notice"],
        &--standby > *[slot="privacy-notice"] {
            display: none;
        }
    }
}
/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
